import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=317820b1&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317820b1",
  null
  
)

export default component.exports